import * as z from "zod";
import { requiredString } from "components/form/utils";

export const deliverableSchema = z.object({
  name: z.string().optional().nullable(),
  type: requiredString(),
  url: requiredString().url("Invalid URL"),
  // Existing files ({ id, ... }) and newly picked ones ({ isNew, file, ... })
  files: z.array(z.any()).optional(),
  skills: z.array(z.union([z.string(), z.number()])).optional(),
});
